/* ================================================================ */
// MAP CONTAINER | Map.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
// Styles
import 'mapbox-gl/dist/mapbox-gl.css';
// Material UI
import withStyles from '@material-ui/styles/withStyles';
import Skeleton from '@material-ui/lab/Skeleton';
// Actions
import { updateMapViewState, updateMapStateById } from '../../actions/Map';
import { fetchStates } from '../../actions/Data/Mapping';
import { fetchPanels } from '../../actions/Data/Content';
// Selectors
import {getStatesByHash, getLoadingStatus, getDefaultState} from '../../selectors/Data';
import {getViewState, getMapLoadingStatus, getActiveLayers, getJSONConfig} from '../../selectors/Map';
// Library Components
import Map from './TempMap';//*/'@myglobe/core/dist/Map';
/* ========================================== */
// Style Settings
/* ========================================== */
const styles = theme => ({
    root: {
        position: 'relative',
        backgroundColor: theme.palette.secondary.main,
        width: '100%',
        height: '100%'
    },
    loadingContainer: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});
/* ========================================== */
/**
 * Map Container
 * -------------
 * Container for deck and mapbox map component
 * linked to the MapReducer
 *
 * @param {object} props component properties
 * @param {object} props.classes style classes
 * @param {bool} props.isLoading loading status
 * @param {string} props.defaultState default state id
 * @param {string} props.mapboxToken mapbox token
 * @param {object} props.mapStyle mapStyle uri or object containing uri
 * @param {string} props.baseMapStyle base map style uri
 * @param {object} props.viewState incoming view state from reducer
 * @param {array} props.markers incoming marker elements from reducer
 * @param {array} props.layers incoming layers from reducer
 * @param {object} props.layerData incoming deck and mapbox layer data
 *
 * @param {func} props.fetchStates fetch state action
 * @param {func} props.updateMapViewState update map viewstate action
 * @param {func} props.updateMapStateById update map state by id
 * @param {func} props.resetMapState resets map state to default
 */
class MapContainer extends Component {
    /* ======================== */
    // CONSTRUCTOR
    /* ======================== */
    constructor(props) {
        super(props);
        this.state = {
            ui: null
            /*deckLayers: [],
            mapboxLayers: [],
            markers: []*/
        };

        // String extension to parse string variable to executable Javascript function
        if (typeof String.prototype.parseFunction != 'function') {
            String.prototype.parseFunction = function () {
                var funcReg = /function *\(([^()]*)\)[ \n\t]*{(.*)}/gmi;
                var match = funcReg.exec(this.replace(/\n/g, ' '));

                if(match) {
                    return new Function(match[1].split(','), match[2]);
                }

                return null;
            };
        }
    }
    shouldComponentUpdate(prevProps) {
        return (prevProps.layerData.deckLayers !== this.props.layerData.deckLayers
            || prevProps.layerData.mapboxLayers !== this.props.layerData.mapboxLayers
            || prevProps.markers !== this.props.markers
            || prevProps.viewState !== this.props.viewState
            || prevProps.mapStyle !== this.props.mapStyle
            || prevProps.isLoading !== this.props.isLoading
        );
    }
    componentDidMount() {
        // UI Building
        /*
        document.getElementById('deckgl-wrapper').addEventListener('contextmenu', evt => evt.preventDefault());
        this.buildUI();
        */

        // Fetch default map state
        /*const globeConfig = this.props.globeConfig;
        const defaultStateID = (globeConfig.visState && globeConfig.visState.id) ? globeConfig.visState.id : 'default';

        // > Load State from DB (if not already loaded)
        this.props.fetchStates([defaultStateID]);
        // > Apply state to map
        const defaultState = this.props.states.byHash//byId.find(state=>state.id === defaultStateID);
        this.props.updateMapState(defaultState);
*/
        //this.loadLayers(this.props.layers);
    }
    componentDidUpdate(prevProps) {
        console.debug(`${MapContainer.displayName} | `, 'componentDidUpdate - ', 'layerData:', this.props.layerData);
        if(!this.props.isLoading && prevProps.isLoading !== this.props.isLoading) {
            // > Load State from DB (if not already loaded)
            //this.props.fetchStates([defaultState]);
            // > Apply state to map
            //const defaultState = this.props.states.byHash//byId.find(state=>state.id === defaultStateID);
            const defaultState = this.props.defaultState || 'default';
            this.props.updateMapStateById(defaultState);
        }
        /*if(prevProps.layers !== this.props.layers) {
            this.loadLayers(this.props.layers);
        }*/
    }
    /* ========================================== */
    /**
     * Load Layers
     * -----------
     * Filters current layers from deck, mapbox,
     * and marker loaded layer arrays in the Map state
     * and sets to state
     */
    /* ========================================== */
    /*loadLayers = (layers) => {

        const deckLayers = this.props.deckLayers.filter(deckLayer=>{
            return layers.some(element=>element.id === deckLayer.props.data[0].id);
        });
        const mapboxLayers = this.props.mapboxLayers.filter(mapboxLayer=>{
            return layers.some(element=>element.id === mapboxLayer.id);
        });
        const markers = this.props.markers.filter(marker=>{
            return layers.some(element=>element.id === marker.id);
        });


        // Get Layers from Loaded Layers
        /*layers.forEach(layer=>{
            // TODO: Use a proper enum for map visTypes
            if(layer.visType === 'deckgl') {
                // Get Deck Layer from loaded deckLayers
                //deckLayers.push(this.props.loadedLayers[layer.id]);
                const deckLayer = this.props.deckLayers.find(dLayer=>dLayer.props.data[0].id === layer.id);
                if(deckLayer) {
                    deckLayers.push(deckLayer);
                }
            } else if(layer.visType === 'mapbox') {
                // Get Mapbox Layer from loaded mapboxLayers
                //mapboxLayers.push(this.props.loadedLayers[layer.id]);
                const mapboxLayer = this.props.mapboxLayers.find(mLayer=>mLayer.id === layer.id);
                if(mapboxLayer) {
                    mapboxLayers.push(mapboxLayer);
                }
            } else {
                // Get Marker Layer from loaded markers
                //markers.push(this.props.loadedLayers[layer.id]);
                const marker = this.props.markers.find(markLayer=>markLayer.id === layer.id);
                if(marker) {
                    markers.push(marker);
                }
            }
        });*/
        /*
        console.debug(`${MapContainer.displayName} | `, 'loadLayers - ', 'deckLayers:', deckLayers, 'mapboxLayers:', mapboxLayers, 'markers:', markers);

        // Set layer arrays to state
        this.setState({deckLayers, mapboxLayers, markers});
    }*/

    /* ========================================== */
    /**
     * Build UI
     * --------
     * Creates map ui components from config
     * (I think this should be a layout container job)
     */
    /* ========================================== */
    /*buildUI() {
        if (this.props.globeConfig.navigation.type == 'sidepanel') {
            this.setState({
                ui: <Timeline onClick={this.loadStory.bind(this)} stories={this.state.stories} panels={this.panels} />
            });
        }
    } */
    /* ========================================== */
    /**
     * Handle View State
     * -----------------
     * Sends view state update to MapReducer
     *
     * @param {object} viewState current view state
     */
    /* ========================================== */
    handleViewState = (viewState) => {
        if(this.props.updateMapViewState) {
            console.debug(`${MapContainer.displayName} | `, 'handleViewState -', 'viewState:', viewState);
            this.props.updateMapViewState(viewState);
        }
    }
    /* ========================================== */
    /**
     * Handle Load
     * -----------
     * Loads map state
     */
    /* ========================================== */
    handleLoad = () => {
        console.debug(`${MapContainer.displayName} | `, 'handleLoad');
        if(this.props.updateMapStateById) {
            const defaultState = this.props.defaultState || 'default';
            //this.props.fetchStates(['default']);
            //const state = this.props.states['default'] || null;//this.props.states.find(state=>state.id === 'gladstone-overview');
            console.debug(`${MapContainer.displayName} | `, 'handleLoad - ', 'defaultState:', defaultState);
            this.props.updateMapStateById(defaultState);
        }
    }
    /* ========================================== */
    /**
     * Handle Reset
     * -----------
     * Triggers map state reset
     */
    /* ========================================== */
    handleReset = () => {
        if(this.props.resetMapState) {
            this.props.resetMapState();
        }
    }
    /* ======================== */
    // RENDER
    /* ======================== */
    render() {
        //console.debug(`${MapContainer.displayName} | `, 'render - ', 'layerData:', this.props.layerData, 'markers:', this.props.markers);
        const classes = this.props.classes;
        const {deckLayers, mapboxLayers} = this.props.layerData;
        if(this.props.isLoading)
            return (
                <div className={classes.root}>
                    <div className={classes.loadingContainer}>
                        <Skeleton variant="rect" width="100%" height="100%" />
                    </div>
                </div>
            );
        else
            return (
                <div className={classes.root}>
                    <Map
                        screen={this.props.screen}
                        mapboxToken={this.props.mapboxToken}
                        mapStyle={this.props.mapStyle}
                        spriteImage={this.props.spriteImage}
                        spriteJSON={this.props.spriteJSON}
                        viewState={this.props.viewState}
                        deckLayers={deckLayers}
                        //deckJsonConverterConfig={this.props.jsonConfig}
                        //loadedLayers={this.props.loadedLayers}
                        mapboxLayers={mapboxLayers}
                        markers={this.props.markers}
                        onViewStateUpdate={this.handleViewState}
                        //onLoad={this.handleLoad}
                    >
                        {(mapbox, deck)=>{
                            //console.debug(`${MapContainer.displayName} | `, 'render - ', 'mapbox:', mapbox, 'deck:', deck, 'ui:', this.state.ui);
                            return this.state.ui;
                        }}
                    </Map>
                </div>
            );
    }
}
/* ======================== */
// PROPS
/* ======================== */
MapContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    screen: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired
    }).isRequired,
    defaultState: PropTypes.string,
    mapboxToken: PropTypes.string.isRequired,
    mapStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({url: PropTypes.string.isRequired})]).isRequired,
    baseMapStyle: PropTypes.string.isRequired,
    viewState: PropTypes.shape({
        longitude: PropTypes.number.isRequired,
        latitude: PropTypes.number.isRequired,
        zoom: PropTypes.number.isRequired,
        pitch: PropTypes.number.isRequired,
        bearing: PropTypes.number.isRequired
    }),
    //deckLayers: PropTypes.arrayOf(PropTypes.object),
    //mapboxLayers: PropTypes.arrayOf(PropTypes.object),
    markers: PropTypes.arrayOf(PropTypes.object),
    layers: PropTypes.arrayOf(PropTypes.string),
    layerData: PropTypes.shape({
        deckLayers: PropTypes.arrayOf(PropTypes.object),
        mapboxLayers: PropTypes.arrayOf(PropTypes.object)
    }),
    // Functions
    fetchStates: PropTypes.func.isRequired,
    updateMapViewState: PropTypes.func.isRequired,
    updateMapStateById: PropTypes.func.isRequired,
    resetMapState: PropTypes.func
};
MapContainer.displayName = 'MapContainer';
MapContainer.whyDidYouRender = true;
/* ========================================== */
// Redux
/* ========================================== */
const mapStateToProps = store => {
    const getAllLoadingStatuses = (store) => {return getLoadingStatus(store, 'globe') || getMapLoadingStatus(store, 'map');};
    //const getDeckLayers = getLayersHashByType('deck');
    //const getLayers = getActiveLayers(store)
    //console.log(getAllLoadingStatuses(store));
    return {
        defaultState: getDefaultState(store),
        screen: store.Global.screen,
        viewState: getViewState(store),//store.Map.viewState,
        //jsonConfig: getJSONConfig(store),
        mapStyle: store.Map.mapStyle,
        spriteJSON: store.Map.spriteJSON,
        spriteImage: store.Map.spriteImage,
        baseMapStyle: store.Map.baseMapStyle,
        mapboxToken: store.Map.mapboxToken,
        //deckLayers: store.Map.deckLayers,
        //loadedLayers: store.Map.loadedLayers,
        layerData: getActiveLayers(store),
        //mapboxLayers: store.Map.mapboxLayers,
        markers: store.Map.markers,
        layers: store.Map.layers,
        //deckLayers: getDeckLayers(store),
        states: getStatesByHash(store),
        isLoading: getAllLoadingStatuses(store)
    };
};
const mapDispatchToProps = dispatch => {
    return bindActionCreators(Object.assign({updateMapViewState, updateMapStateById, /*resetMapState,*/ fetchPanels, fetchStates,/*updateMapStyle, resetMap,*/ dispatch}), dispatch);
};
/* ========================================== */
// Export
/* ========================================== */
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MapContainer));